<template>
  <div class="sort-options">
    <div class="search-menu-label">
      SORT
    </div>
  <div class="sort-options-holder">
    <SortResults :label="'Alphabetic'" :orderByType="'name'"/>
    <SortResults :label="'Upload Date'" :orderByType="'dateAddedUtc'"/>
  </div>
  </div>
</template>

<script>
import SortResults from '@/components/libraries/search/SortResults';

export default {
  name: 'SortOptions',
  components: {
    SortResults
  }
  
};
</script>

<style scoped>

.sort-options-holder {
  height: 30px;
  display: flex;
  gap: 5px;
}

</style>